import { ActionIcon, Button, Group, Menu, Text } from "@mantine/core";
import { useAuthState, useSignOut } from "react-firebase-hooks/auth";
import { auth, functions, testEmails } from "../../../config/firebase";
import {
  IconBrandWhatsapp,
  IconCalendarPlus,
  IconPower,
  IconUser,
} from "@tabler/icons-react";
import { httpsCallable } from "firebase/functions";
import { useState } from "react";

const sendTestMessage = httpsCallable(functions, "sendTestMessage");

const Header = () => {
  const [user] = useAuthState(auth);
  const [signOut] = useSignOut(auth);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");

  const isTestUser = Boolean(user?.email && testEmails.includes(user.email));

  const handleSendTestMessage = async () => {
    setSending(true);
    setStatus("idle");

    try {
      await sendTestMessage();
      setStatus("success");
    } catch {
      setStatus("error");
    } finally {
      setSending(false);
    }
  };

  const testMessageLabel =
    status === "success"
      ? "Message envoyé"
      : status === "error"
        ? "Échec de l'envoi"
        : "Message de test";
  const testMessageColor =
    status === "success" ? "teal" : status === "error" ? "red" : "green";

  return (
    <div className="flex items-center justify-between h-full px-4">
      <Text component="a" href={window.location.origin}>
        <b>Sayer family</b> • Calendrier Val d'Isère
      </Text>
      <Group gap="xs">
        {isTestUser && (
          <>
            <Button
              size="xs"
              variant="light"
              color={testMessageColor}
              leftSection={<IconBrandWhatsapp size={18} />}
              onClick={handleSendTestMessage}
              loading={sending}
              visibleFrom="sm"
            >
              {testMessageLabel}
            </Button>
            <ActionIcon
              variant="light"
              color={testMessageColor}
              onClick={handleSendTestMessage}
              loading={sending}
              hiddenFrom="sm"
              aria-label={testMessageLabel}
            >
              <IconBrandWhatsapp size={18} />
            </ActionIcon>
          </>
        )}
        <Button
          component="a"
          href={window.location.origin + "/sync"}
          size="xs"
          variant="default"
          leftSection={<IconCalendarPlus size={18} />}
          visibleFrom="sm"
        >
          Ajouter à mon calendrier
        </Button>
        <ActionIcon
          component="a"
          href={window.location.origin + "/sync"}
          variant="default"
          hiddenFrom="sm"
        >
          <IconCalendarPlus size={18} />
        </ActionIcon>
        <Menu withinPortal>
          <Menu.Target>
            <ActionIcon variant="light">
              <IconUser size={18} />
            </ActionIcon>
          </Menu.Target>

          <Menu.Dropdown>
            {user?.email && <Menu.Label>{user.email}</Menu.Label>}
            <Menu.Item
              color="red"
              leftSection={<IconPower size={18} />}
              onClick={signOut}
            >
              Se déconnecter
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
    </div>
  );
};

export default Header;
